import React, { useContext, useEffect, useState } from "react";
import { MdEdit } from "react-icons/md";
import { FaTrash } from "react-icons/fa";
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import { GlobalContext } from "../Context/GlobalState";
import { getBaseUrls } from "../Utils/utilFunction";
import { BASE_URL_API_BLOG } from "../Utils/Constant";
import { apibasicauth } from "../Utils/Credentials";
const Blogs = () => {
  const {
    siteid,
    setsiteid,
    siteurl,
    setURL,
    setTransactionLoaderState,
    Productname,
  } = useContext(GlobalContext);
  const { password, username } = apibasicauth;
  const base64Credentials =
    typeof window === "undefined"
      ? Buffer.from(`${username}:${password}`).toString("base64")
      : btoa(`${username}:${password}`);
  const [blogdata, setBlogData] = useState([]);
  const [loading, setLoading] = useState(false);
  const Getproductblogs = async () => {
    setTransactionLoaderState(true);
    setLoading(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          webid: siteid,
          // type: "Edit",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_BLOG}/GetAllProductBlog`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        setBlogData(data.data || []);
      } else {
        console.error("Failed to fetch blogs:", data.msg);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setTransactionLoaderState(false);
      setLoading(false);
    }
  };
  const DeleteBlog = async (tempid) => {
    setTransactionLoaderState(true);
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          tempid: tempid,
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_BLOG}/DeleteBlogByProduct`,
        requestOptions
      );
      const data = await res.json();

      if (data.status === "0") {
        Getproductblogs();
        swal("Success", data.msg, "success");
      } else {
        console.error("Failed to delete blog:", data.msg);
        swal("Error", data.msg, "error");
      }
    } catch (error) {
      console.log("error", error);
      swal("Error", "Something went wrong!", "error");
    } finally {
      setTransactionLoaderState(false);
    }
  };

  useEffect(() => {
    Getproductblogs();
  }, [Productname]);

  return (
    <div
      className="m-3"
      style={{
        height: "85vh",
        overflowY: "auto",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      <style>
        {`
        .hide-scrollbar::-webkit-scrollbar {
          display: none;
        }
      `}
      </style>
      <h4>All Blog </h4>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "60vh" }}
        >
          <Spinner animation="border" variant="success" />
        </div>
      ) : (
        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th
                className="text-center"
                style={{ background: "#A1D6B2", color: "#16325B" }}
              >
                Sr.
              </th>
              <th
                className="text-center"
                style={{
                  background: "#A1D6B2",
                  color: "#16325B",
                  width: "20vw",
                }}
              >
                Title
              </th>
              <th
                className="text-center"
                style={{
                  background: "#A1D6B2",
                  color: "#16325B",
                  width: "20vw",
                }}
              >
                Excerpt
              </th>
              <th
                className="text-center"
                style={{ background: "#A1D6B2", color: "#16325B" }}
              >
                Author
              </th>
              <th
                className="text-center"
                style={{ background: "#A1D6B2", color: "#16325B" }}
              >
                Image
              </th>
              <th
                className="text-center"
                style={{ background: "#A1D6B2", color: "#16325B" }}
              >
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {blogdata.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center">
                  No data found
                </td>
              </tr>
            ) : (
              blogdata.map((blog, index) => (
                <tr key={blog.id}>
                  <td className="text-center align-middle">{index + 1}</td>
                  <td className="text-center align-middle font-weight-bold">
                    {blog.title}
                  </td>
                  <td className="text-center align-middle">
                    {blog.excerpt?.split(" ").slice(0, 15).join(" ")}...
                  </td>
                  <td className="text-center align-middle">
                    {blog.author_name}
                  </td>
                  <td className="text-center align-middle">
                    <img
                      src={blog.image_url}
                      alt={blog.image_desc || "blog image"}
                      title={blog.image_desc || blog.title}
                      style={{
                        width: "80px",
                        height: "auto",
                        borderRadius: "5px",
                      }}
                    />
                  </td>
                  <td className="text-center align-middle">
                    <div className="d-flex justify-content-center gap-2">
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-top">Edit</Tooltip>}
                      >
                        <Link
                          to={`/blog/Editblog`}
                          onClick={() => {
                            sessionStorage.setItem(
                              "Editblogid",
                              JSON.stringify(blog)
                            );
                          }}
                        >
                          <MdEdit
                            style={{ fontSize: "1.3rem", color: "green" }}
                          />
                        </Link>
                      </OverlayTrigger>

                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="tooltip-top">Delete</Tooltip>}
                      >
                        <FaTrash
                          style={{
                            fontSize: "1rem",
                            color: "red",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            swal({
                              title: "Are you sure?",
                              text: "Once deleted, you will not be able to recover this blog!",
                              icon: "warning",
                              buttons: true,
                              dangerMode: true,
                            }).then((willDelete) => {
                              if (willDelete) {
                                DeleteBlog(blog.tempid);
                              }
                            });
                          }}
                        />
                      </OverlayTrigger>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Blogs;
